// extracted by mini-css-extract-plugin
module.exports = {"inputCheckbox":"InputCheckbox_inputCheckbox__zuzGc","manualChecked":"InputCheckbox_manualChecked__vOqTi","span":"InputCheckbox_span__wmG7j"};